/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 12,
    height: 9,
    viewBox: '0 0 12 9',
    data: '<path pid="0" _fill="#fff" d="M2.506 3.33l2.182 2.043L9.467.855a1.252 1.252 0 011.696 0 1.085 1.085 0 010 1.599L5.55 7.762a1.191 1.191 0 01-.017.015l-.044.042a1.252 1.252 0 01-1.697 0 1.131 1.131 0 01-.239-.32L.81 4.929a1.085 1.085 0 010-1.6 1.252 1.252 0 011.696 0z"/>'
  }
})
